import * as actionTypes from '../constants/actionType';
import initialState from './initialState';
import * as helpers from "../helpers";

export default function mListNavReducer(state = initialState.mListNav, action) {
  switch (action.type) {
    case actionTypes.MLISTNAV_LOAD_START:
      return helpers.updateOrAdd(state, {
        id: action.id,
        isLoading: true
      });

    case actionTypes.MLISTNAV_LOAD_FAIL:
      return helpers.updateOrAdd(state, {
        id: action.id,
        isLoading: false,
        error: action.error
      });

    case actionTypes.MLISTNAV_LOAD_SUCCESS: {
      const next = helpers.updateOrAdd(state, {
        ...action.data,
        isLoading: false,
        error: undefined
      });
      if (!action.data.documentId || action.data.documentId === action.data.id) return next;
      return helpers.updateOrAdd(next, {
        ...action.data,
        id: action.data.documentId,
        isLoading: false,
        error: undefined
      });
    }

    default:
      return state;
  }
}
